import { ThemeConfig } from "antd";

export const antdThemeConfig: ThemeConfig = {
  token: {
    colorPrimary: "#009B3A",
  },
  components: {
    Input: {
      colorTextDisabled: "black",
    },
    Select: {
      colorTextDisabled: "black",
    },
    InputNumber: {
      colorTextDisabled: "black",
    },
    DatePicker: {
      colorTextDisabled: "black",
    },
    Checkbox: {
      colorTextDisabled: "black",
    },
    Button: {
      colorPrimary: "#009B3A",
    },
    Layout: {
      siderBg: "#EEF8E9",
    },
    Menu: {
      itemBg: "#EEF8E9",
      itemSelectedBg: "#009B3A",
      itemSelectedColor: "#fff",
    },
    Table: {
      rowHoverBg: "#F3FFED",
    },
  },
};
